import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectSaved, selectSaving, selectError, selectInstructor } from '../selectors/instructor.selector';
import { instructorActions } from '../actions/instructor.actions';
import { InstructorValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class InstructorFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly saving$ = this.store.select(selectSaving);
    readonly saved$ = this.store.select(selectSaved);
    readonly instructor$ = this.store.select(selectInstructor);
    readonly instructorNonNullable$ = this.store.select(selectInstructor).pipe(filter((instructor) => instructor !== null));

    readonly instructor = this.store.selectSignal(selectInstructor);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = this.store.selectSignal(selectError);

    getInstructor(id: string): void {
        this.store.dispatch(instructorActions.getInstructor({ id }));
    }

    createInstructor(value: InstructorValue): void {
        this.store.dispatch(instructorActions.createInstructor({ value }));
    }

    updateInstructor(id: string, value: InstructorValue): void {
        this.store.dispatch(instructorActions.updateInstructor({ id, value }));
    }

    deleteInstructor(id: string): void {
        this.store.dispatch(instructorActions.deleteInstructor({ id }));
    }

    clear(): void {
        this.store.dispatch(instructorActions.clear());
    }
}
